const MAX_TOOLBAR_ITEMS = 8;
const ToolbarElement = require("../elements/toolbar.js");
const ButtonIcon = require("../elements/buttonicon.js");
const ButtonImage = require("../elements/buttonimage.js");

module.exports = function GameToolbar(state, emit) {
  function GlitchButton(itemId) {
    const glitch = state.availableGlitches.find((g) => g.id === itemId);
    const isTutorialHighlighted = shouldItemBeHighlighted(
      glitch,
      "glitch",
      state
    );
    const disabled =
      state.disabledToolbarIcons.indexOf(glitch.id) !== -1 ||
      state.isMenuOpen ||
      (state.applyingGlitch && state.selectedGlitchId === glitch.id);
    return ButtonIcon({
      disabled,
      highlighted: isTutorialHighlighted,
      id: `toolbar-glitch-${glitch.id}`,
      color: glitch.color,
      icon: glitch.icon,
      selected: state.selectedGlitchId === glitch.id,
      pickable: true,
      onMouseDown: (e) => {
        const mini = ButtonIcon({
          color: glitch.color,
          icon: glitch.icon,
        });
        emit("start-drag", mini, e);
        // If inventory is closed
        if (state.isInventoryOpen) {
          emit("start-moving-glitch", glitch.id);
        } else {
          emit("start-applying-glitch", glitch.id);
        }
      },
      onMouseUp: () => {
        if (state.pickingGlitch || state.pickingPart) {
          emit("pick-and-replace-glitch", itemId);
        }
      },
      onMouseOver: () => {
        if (state.movingGlitch || state.movingPart) {
          emit("swap-selected-item", itemId);
        }
      },
    });
  }

  if (!state.toolbar) {
    state.toolbar = {
      glitches: [],
      parts: [],
    };
  }

  if (!state.toolbar.items) {
    state.toolbar.items = [...state.toolbar.glitches, ...state.toolbar.parts];
  }

  const categoryA = state.toolbar.items.map((itemId) => {
    const glitch = state.availableGlitches.find((g) => g.id === itemId);
    if (glitch) {
      return GlitchButton(itemId);
    } else {
      return PartButton(itemId);
    }
  });

  const itemCount = state.toolbar.items.length;

  if (
    state.isInventoryOpen &&
    state.selectedInventoryCategory === "glitch" &&
    itemCount < MAX_TOOLBAR_ITEMS
  ) {
    const diff = MAX_TOOLBAR_ITEMS - itemCount;
    for (let i = 0; i < diff; i++) {
      categoryA.push(
        ButtonIcon({
          color: "darkgrey",
          onMouseUp: () => emit("pick-glitch"),
        })
      );
    }
  }
  if (
    state.isInventoryOpen &&
    state.selectedInventoryCategory === "part" &&
    itemCount < MAX_TOOLBAR_ITEMS
  ) {
    const diff = MAX_TOOLBAR_ITEMS - itemCount;
    for (let i = 0; i < diff; i++) {
      categoryA.push(
        ButtonIcon({
          type: "circle",
          color: "darkgrey",
          onMouseUp: () => emit("pick-part"),
        })
      );
    }
  }

  let inventoryHidden =
    state.playingTutorial && !state.currentTutorial.showInventoryButton;
  
  const isToolbarHighlighted = shouldToolbarBeHighlighted(state);
  
  return ToolbarElement({
    categoryA,
    categoryB: [],
    categoryC: ButtonIcon({
      disabled: state.isMenuOpen,
      selected: false,
      hidden: inventoryHidden,
      id: "toggle-inventory-button",
      icon: state.isInventoryOpen ? "cross" : "plus",
      onClick: () => emit("toggle-inventory"),
    }),
    categoryCHidden: inventoryHidden,
    id: isToolbarHighlighted ? "toolbar" : null,
  });

  function PartButton(itemId) {
    const part = state.availableParts.find((g) => g.id === itemId);
    if (!part) {
      return null;
    }
    const isTutorialHighlighted = shouldItemBeHighlighted(part, "part", state);
    const disabled =
      state.disabledToolbarIcons.indexOf(part.id) !== -1 ||
      state.isMenuOpen ||
      (state.importingPart && state.selectedPartId === part.id);
    return ButtonImage({
      disabled,
      id: `toolbar-part-${part.id}`,
      type: "circle",
      highlighted: isTutorialHighlighted,

      image: part.image,
      pickable: true,
      selected: state.selectedPartId === part.id,
      onMouseDown: (e) => {
        const mini = ButtonImage({
          type: "circle",
          image: part.image,
        });
        emit("start-drag", mini, e);
        if (state.isInventoryOpen) {
          emit("start-moving-part", part.id);
        } else {
          emit("start-importing-part", part.id);
        }
      },
      onMouseUp: () => {
        if (state.pickingPart || state.pickingGlitch) {
          emit("pick-and-replace-part", itemId);
        }
      },
      onMouseOver: () => {
        if (state.movingPart || state.movingGlitch) {
          emit("swap-selected-item", itemId);
        }
      },
    });
  }
};

function shouldItemBeHighlighted(item, itemType, state) {
  const { currentTutorial, currentTutorialStep } = state;
  if (!currentTutorial) {
    return false;
  }
  const currentStep = currentTutorial[currentTutorialStep];
  if (!currentStep || !currentStep.highlights) {
    return false;
  }
  if (
    currentStep.highlights.toolbarGlitches &&
    itemType === "glitch" &&
    currentStep.highlights.toolbarGlitches.length > 0
  ) {
    return currentStep.highlights.toolbarGlitches.indexOf(item.id) !== -1;
  } else if (
    currentStep.highlights.toolbarParts &&
    itemType === "part" &&
    currentStep.highlights.toolbarParts.length > 0
  ) {
    return currentStep.highlights.toolbarParts.indexOf(item.id) !== -1;
  }
  return false;
}

function shouldToolbarBeHighlighted(state) {
  const { currentTutorial, currentTutorialStep } = state;
  if (!currentTutorial) {
    return false;
  }
  const currentStep = currentTutorial[currentTutorialStep];
  if (!currentStep || !currentStep.highlights) {
    return false;
  }
  if (currentStep.highlights.htmlElements && currentStep.highlights.htmlElements.length > 0) {
    return currentStep.highlights.htmlElements.some(selector => selector === "#toolbar");
  }
  return false;
}
